/**
 * @fileoverview GET-style handler for the "/engagement/segments_and_filters_sentence_array/:app_group_id" endpoint
 * Uses POST under the hood due to potentially large params.
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { EngagementSegmentsAndFiltersSentenceArrayResult } from "./types";

export const getEngagementSegmentsAndFiltersSentenceArray = reactQueryFetcherAdapter(
  "/engagement/segments_and_filters_sentence_array/:app_group_id",
  (
    signal: AbortSignal,
    { appGroupId, segmentIds, filters }: { appGroupId: string; segmentIds: string[]; filters: unknown[] }
  ): Promise<EngagementSegmentsAndFiltersSentenceArrayResult> => {
    return fetch(
      `/engagement/segments_and_filters_sentence_array/${appGroupId}`,
      "POST",
      {
        segment_ids: segmentIds,
        filters,
      },
      { signal }
    );
  }
);
